import createReactComponent from '../createReactComponent';
var Video = createReactComponent('Video', [['polygon', {
  points: '23 7 16 12 23 17 23 7',
  key: '1uwpto'
}], ['rect', {
  x: '1',
  y: '5',
  width: '15',
  height: '14',
  rx: '2',
  ry: '2',
  key: '1dasyj'
}]]);
export default Video;